<script lang="ts">
  import { onMount } from "svelte";
  import BaseStep from "./BaseStep.svelte";
  import { getMenuData, onFullySpecifiedSocialGift } from "../../lib/helpers/steps/menu";
  import { getCopy } from "../../lib/stores/copy";
  import SharedHeading from "../SharedHeading.svelte";
  import LoadingScreen from "../LoadingScreen.svelte";
  import type { MenuData } from "../../lib/helpers/steps/menuItems";
  import { sessionStore } from "../../lib/stores/session";
  import CustomHtml from "../CustomHTML.svelte";
  import SingleSelectionMenu from "../Menu/SingleSelectionMenu.svelte";
  import BundleSelectionMenu from "../Menu/BundleSelectionMenu.svelte";
  import MultipleSelectionMenu from "../Menu/MultipleSelectionMenu.svelte";
  import { getSearchParam } from "../../lib/helpers/document";

  export let currentRoute;

  let isLoading = true;
  let menuData: MenuData = { menuItems: [], socialGiftBundleItems: [] };
  let isChildLoading = false;
  let requiredSelectionCount: number | undefined = undefined;

  onMount(async () => {
    const isFullySpecifiedBundle = $sessionStore.socialGiftingMode === "bundle" && getSearchParam("ssm") === "true";

    if ($sessionStore.socialGiftingMode === "full" || isFullySpecifiedBundle) {
      return onFullySpecifiedSocialGift();
    }

    isLoading = true;
    const result = await getMenuData();
    ({ menuData, requiredSelectionCount } = result);
    isLoading = false;
  });

  $: copy = $getCopy("chooseItem") as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    {#if isLoading}
      <LoadingScreen />
    {:else}
      {#if !isChildLoading}
        <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
      {/if}
      {#if $sessionStore.socialGiftingMode === "bundle"}
        <BundleSelectionMenu {menuData} bind:isSaving={isChildLoading} />
      {:else if requiredSelectionCount}
        <MultipleSelectionMenu {menuData} {requiredSelectionCount} bind:isSaving={isChildLoading} />
      {:else}
        <SingleSelectionMenu {menuData} />
      {/if}
      <CustomHtml customHtml={copy.customHtml} />
    {/if}
  </svelte:fragment>
</BaseStep>
